class Devis {

	constructor(){  
		this.form = document.querySelector('[data-component="form-devis"]');

		if(this.form){
			this.message = document.getElementById('selectMessage');
			this._init();
		}
	}

	_init(){
	  document.addEventListener('DOMContentLoaded', (event) => {
			
			this.message.value = this.form.getAttribute('data-content');

	  });
	}

}

export const devis = new Devis();